export const Modifier = {
    "menuItem_ID":0,
    "localizeID": "en",
    "compID": 1,
    "menuItem_Name": "",
    "menuItem_KitchenDisplayName": "",
    "menuItem_ServingSize": "",
    "menuItem_PreparationTime": "",
    "menuItem_Detail": "",
    "menuItem_SalePrice": 0.00,
    "menuItem_Image": "",
    "menuItem_Orderby": 1,
    "menuItem_Publish": true,
    "menuItem_DataCreated": "2025-03-27T10:00:00Z",
    "menuItem_ExpiryDate": "2026-03-27T23:59:59Z",
    "menuItem_DateModified": "2025-03-27T12:00:00Z",
    "menuItem_ASTime": "",
    "menuItem_AETime": "",
    "menuItem_Rating": 4,
    "menuItem_Homefeatured": false,
    "menuItem_featured": false,
    "menuItem_HaveModifier": false,
    "menuItem_IsModifier": false,
    "menuItem_ModifierType": "",
    "menuItem_IsFavorite": false,
    "menuItem_ColorCode": "#FF5733",
    "menuItem_DeliveryPrice": 0,
    "menuItem_TakeAwayPrice": 0,
    "brand_ID": 0,
    "ingredientID": 0,
    "menuItem_CostPrice": 0,
    "retail_Markup": 0,
    "delivery_Markup": 0,
    "menuItem_TaxPercentage": 0,
    "online_Markup": 0,
    "menuItem_BarCode": "",
    "menuItem_SKU": "",
    "menuItem_Type": "",
    "stadardUnit": 1,
    "unitSize": 1,
    "current_Quantity": 0,
    "reorder_Quantity": 0,
    "reorder_Level": 0,
    "isActiveMobileApp": false,
    "is_OutOfStock": false,
    "isSellOnTill": true,
    "isAllowedtoSetPriceatThePointofSale": false,
    "isTaxExempt": false,
    "isPreventGainingLoyalty": false,
    "isHaveCustomerSpecificPricing": false,
    "isProductisScannableOnly": false,
    "orderQuantityLimit": null,
    "isMasterProduct": false,
    "mP_UnitOfSale": "",
    "mP_VolumnOfSale": null,
    "itHasAMasterProduct": false,
    "itsMasterProductID": null,
    "menuItem_HasVariant": false,
    "parentMenuItemID": 0,
    "isArchieve": false,
    "hasAllergen": true,
    "allergens": "egg",
    "reportCat_ID": 0,
    "appMode": "testing",
    "menuItem_IsDefaultModifier": false,
    "menuItem_DefaultModifierTitle": "",
    "menuItem_RootType": "Food",
    "is_ShowInKiosk": false,
    "isShowNotificationExpDate": false,
    "isShowSocialMediaLink": false,
    "menuItem_SEOTitle": "",
    "menuItem_SEODescription": "",
    "menuItem_Permalink": "",
    "menuItem_ImageAltText": "",
    "isSearching": false,
    "menuItem_IsVariant": false,
    "menuItem_IsDefaultVariant": false,
    "menuItem_DefaultVariantTitle": "",
    "menuitem_VariantParentID": 0,
};